<template>
  <v-menu bottom
          class="dropdown-menu"
          z-index="1000"
          v-model="openMenu"
          :top="top"
          :offset-y="offsetY"
          :offset-x="offsetX"
          :left="left"
          :right="right"
          :disabled="disabled">
    <template v-slot:activator="{ on }">
            <span class="activator-container" v-on="on" @click.stop="openMenuFunc">
                <slot/>
            </span>
    </template>

    <div>
      <v-list
        v-click-outside="closeMenu"
        class="dropdown-menu-list-wrapper">
        <v-list-item
          :data-qa="item.action"
          v-for="(item, i) in items"
          :key="i"
          :disabled="item.disabled"
          @click="onItemClick(item)">
          <v-icon small v-if="item.icon">{{ item.icon }}</v-icon>
          <VSvgIcon v-if="item.svg" :tag="item.svg_tag" size="24" :icon="item.svg" class="svg-icon"/>
          <v-list-item-title v-if="!item.items">
            {{item.titleKey ? $t(item.titleKey) : item.title}}
          </v-list-item-title>
          <v-list-item-title
            v-if="item.items">
            <DropdownMenu
              :items="item.items"
              :offsetX="true"
              @item-clicked="onItemClick">
              <v-list-item-title>{{item.titleKey ? $t(item.titleKey) : item.title}}
                <v-icon size="15" class="additional-icon icon-gallery_right"/>
              </v-list-item-title>
            </DropdownMenu>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
  </v-menu>
</template>

<script>
  import VSvgIcon from '../VSvgIcon'
  import ClickOutside from 'vue-click-outside'

  export default {
    name: "DropdownMenu",
    components: {
      VSvgIcon
    },
    props: {
      items: {
        type: Array,
        required: true,
      },
      top: {
        type: Boolean,
        required: false,
      },
      offsetX: {
        type: Boolean,
        required: false,
      },
      offsetY: {
        type: Boolean,
        required: false,
      },
      left: {
        type: Boolean,
        required: false,
      },
      right: {
        type: Boolean,
        required: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        openMenu: false
      }
    },
    directives: {
      ClickOutside
    },
    methods: {
      closeMenu() {
        this.openMenu = false
      },
      openMenuFunc() {
        this.openMenu = true
      },
      onItemClick(item) {
        !item.items && this.$emit('item-clicked', item)
      }
    }
  }
</script>

<style lang="scss">
  @import '@/assets/scss/abstract/_i18n-mixins';

  .dropdown-menu-list-wrapper {
    &.v-list .v-list-item {
      min-height: 40px;

      .v-list-item__title {
        font-size: 13px;
      }

      .v-icon .additional-icon{
        margin-inline-start: auto ;
      }
    }

    .v-icon {
      margin-inline-end: 12px;
    }

    .svg-icon {
      @include i-margin-mirror(0, 12px);
      min-width: 24px;
    }

  }
</style>
